// UI端数据模型定义（用于Zustand存储）

// Memo内容标记枚举
export enum MemoContentMark {
  /**
   * 无内容标记
   */
  NONE = 0,

  /**
   * 文本内容
   */
  TEXT = 1,

  /**
   * 标签内容
   */
  TAG = 2,

  /**
   * 对象内容
   */
  OBJECT = 4
}

// 状态码枚举
export enum StateCode {
  /**
   * 无效状态
   */
  INVALID = 0,

  /**
   * 正常状态
   */
  NORMAL = 1
}

// Section 相关UI数据模型
export interface UISection {
  userId: string;
  guid: string;
  createTimestamp: number;
  stateCode: number;
  modifyTimestamp: number;
  name: string;
  sectionType: number;
  hasShare: boolean;
  shareTypes: number[];
  // UI特定字段
  updateStatus: number;
  isExpanded?: boolean;
  isSelected?: boolean;
}

// Group 相关UI数据模型
export interface UIGroup {
  userId: string;
  guid: string;
  createTimestamp: number;
  stateCode: number;
  description: string;
  modifyTimestamp: number;
  name: string;
  sectionId: string;
  hasShare: boolean;
  shareTypes: number[];
  // UI特定字段
  updateStatus: number;
  memoCount?: number;
  isExpanded?: boolean;
  isSelected?: boolean;
}

// Memo 相关UI数据模型
export interface UIMemo {
  userId: string;
  guid: string;
  title: string;
  createTimestamp: number;
  modifyTimestamp: number;
  stateCode: number;
  groupId: string;
  syncStateCode: number;
  hasShare: boolean;
  shareTypes: number[];
  contentMark: number;
  // UI特定字段
  updateStatus: number;
  hit?: number;
  isSelected?: boolean;
  isEditing?: boolean;
}

// MemoContent 相关UI数据模型
export interface UIMemoContent {
  memoId: string;
  /** @deprecated 内容已迁移至CRDT，使用 useMemoCrdt 获取实时内容 */
  content: string;
}

// Tag 相关UI数据模型
export interface UITag {
  guid: string;
  createTimestamp: number;
  content: string;
  userId: string;
  // UI特定字段
  usageCount?: number;
}

export interface UITagItem {
  label: string;
  level: number; // 修改为数字类型，支持权重值
  // UI特定字段
  color?: string;
}

export interface UIMemoTag {
  memoId: string;
  tags: UITagItem[];
  // UI特定字段
  lastUpdated?: number;
}

// MemoObject 相关UI数据模型
export interface UIMemoObject {
  memoId: string;
  objects: UIMemoObjectItem[];
  // UI特定字段
  lastUpdated?: number;
}

export interface UIMemoObjectItem {
  label: string;
  type: string;
  // 原始数据字段，用于存储attributes信息
  attributes?: UIAttribute[];
  // UI特定字段
  color?: string;
}

// Attribute 相关UI数据模型// 属性接口
export interface UIAttribute {
  key: string;
  values: string[];
  valueType: string;
  attribute?: string; // 兼容旧字段名
  content?: string; // 兼容旧字段名
  isVisible?: boolean;
}

// Representation 相关UI数据模型
export interface UIRepresentation {
  guid: string;
  createTimestamp: number;
  content: string;
  // UI特定字段
  isVisible?: boolean;
}

export interface UIRepresentationList {
  guid: string;
  representations: UIRepresentation[];
}

// Share 相关UI数据模型
export interface UIShareStatus {
  guid: string;
  createTimestamp: number;
  modifyTimestamp: number;
  shareInfo: UIShareInfo[];
}

export interface UIShareInfo {
  targetType: number;
  targetId: string;
  displayName?: string;
  // UI特定字段
  isExpanded?: boolean;
}

// UserMark 相关UI数据模型
export interface UIUserMark {
  id: string;
  label: string;
  // UI特定字段
  isSelected?: boolean;
}

// UserGroup 相关UI数据模型
export interface UIUserGroup {
  userId: string;
  guid: string;
  createTimestamp: number;
  stateCode: number;
  modifyTimestamp: number;
  name: string;
  userMarks: UIUserMark[];
  // UI特定字段
  memberCount?: number;
  isExpanded?: boolean;
}

// User 相关UI数据模型
export interface UIUser {
  userId: string;
  name: string;
  email: string;
  avatar?: string;
  // UI特定字段
  lastActive?: number;
  isOnline?: boolean;
}

// 搜索相关UI数据模型
export interface UIMemoSearch {
  userId: string;
  guid: string;
  title: string;
  createTimestamp: number;
  modifyTimestamp: number;
  stateCode: number;
  groupId: string;
  hit: number;
  // UI特定字段
  highlightText?: string;
  snippet?: string;
}

// 索引相关UI数据模型
export interface UIMemoIndex {
  createTimestamp: number;
  modifyTimestamp: number;
  stateCode: number;
  content: string;
  guid: string; // 对应memo guid
  // UI特定字段
  indexes?: UIIndexItem[]; // 从content解析出来的索引项数组
}

export interface UIIndexItem {
  label: string;
  level: string;
}

// 通用UI状态字段
export interface UIState {
  status: 'idle' | 'loading' | 'failed';
  error?: string;
  lastUpdated?: number;
}
